import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { TranslationKeysUtil } from '~shared/utils/translation-keys.util';

import { AdvancedFormUtil } from '../utils/advanced-form.util';
import { IFieldValidationError } from '../models/advanced-form-validation.model';

@Pipe({
  name: 'errorMessage',
})
export class ErrorMessagePipe implements PipeTransform {
  private errorMessage: string;

  constructor(
    private translateService: TranslateService,
  ) {}

  public transform(errors: { [key: string]: any }, fieldName: string): string {
    const validationError = errors && AdvancedFormUtil.getFirstValidationError(fieldName, errors);

    if (validationError && validationError.isAsync) {
      this.errorMessage = validationError.payload.reason;
    } else if (validationError) {
      this.fetchTranslation(validationError).subscribe((errorMessage: string) => {
        this.errorMessage = errorMessage;
      });
    } else {
      this.errorMessage = '';
    }

    return this.errorMessage;
  }

  private fetchTranslation(validationError: IFieldValidationError) {
    const unique = TranslationKeysUtil.getErrorMessage(validationError.errorName, validationError.fieldName);
    const regular = TranslationKeysUtil.getErrorMessage(validationError.errorName);

    return this.translateService.get(unique, validationError.payload).pipe(
      switchMap((translation: string) => {
        const isTranslated = translation !== unique;
        return isTranslated ? of(translation) : this.translateService.get(regular, validationError.payload);
      }),
    );
  }
}
